const UniqueIcon = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 10C4 5.58172 7.58172 2 12 2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4C8.68629 4 6 6.68629 6 10C6 10.5523 5.55228 11 5 11C4.44772 11 4 10.5523 4 10Z"
				fill="currentColor"
			/>
			<path
				d="M19 9C19.5523 9 20 9.44772 20 10V14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 13.4477 4.44772 13 5 13C5.55228 13 6 13.4477 6 14C6 17.3137 8.68629 20 12 20C15.3137 20 18 17.3137 18 14V10C18 9.44772 18.4477 9 19 9Z"
				fill="currentColor"
			/>
			<path
				d="M8.85853 6.57878C9.72713 5.80203 10.8674 5.5 12 5.5C14.4786 5.5 16.5 7.47225 16.5 10V14C16.5 14.5523 16.0523 15 15.5 15C14.9477 15 14.5 14.5523 14.5 14V10C14.5 8.59016 13.3874 7.5 12 7.5C11.1996 7.5 10.5899 7.71358 10.1917 8.06962C9.81298 8.40831 9.5 8.98773 9.5 10V14C9.5 15.4098 10.6126 16.5 12 16.5C12.5523 16.5 13 16.9477 13 17.5C13 18.0523 12.5523 18.5 12 18.5C9.52141 18.5 7.5 16.5278 7.5 14V10C7.5 8.54348 7.97052 7.3729 8.85853 6.57878Z"
				fill="currentColor"
			/>
			<path
				d="M13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V10Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export default UniqueIcon
